import React, { useMemo } from "react";
import CitiesList from "../categoriesList/citiesList";
import RedBreadcrumb from "@/components/RedBreadCrumb/RedBreadCrumb";
import css from "@/src/pages/.module.scss";
import styles from "./projects.module.scss";
import ProjectsGrid from "@/containers/project-screen/ProjectsGrid";
import SEO from "@/components/seo";
import { usePath } from "@/contexts/path/path";

const SCREEN_TITLE = "المشاريع العقارية";
const SCREEN_DESCRIPTION =
  "استكشف المشاريع العقارية في $city واختر من بين العديد من المشاريع العقارية المتوفرة في$suffix.";
const ProjectsScreen = (props) => {
  const { city: activeCity } = usePath();
  const screenTitle = useMemo(() => {
    if (activeCity) {
      return `${SCREEN_TITLE} في ${activeCity.name}`;
    }
    return SCREEN_TITLE;
  }, [activeCity]);
  const screenDescription = useMemo(() => {
    if (activeCity) {
      return SCREEN_DESCRIPTION.replace("$city", activeCity.name).replace(
        "$suffix",
        "ها",
      );
    }
    return SCREEN_DESCRIPTION.replace(
      "$city",
      "المملكة العربية السعودية",
    ).replace("$suffix", "مختلف المدن السعودية ");
  }, [activeCity]);
  return (
    <div className={styles.projectsScreen}>
      <SEO title={screenTitle} description={screenDescription} />
      <CitiesList />
      <div className={css.container}>
        <RedBreadcrumb />
        <h2 className={styles.title}>
          {activeCity
            ? activeCity.title || `مشاريع عقارية في ${activeCity?.name}`
            : "المشاريع العقارية"}
        </h2>
        <ProjectsGrid {...props} />
      </div>
    </div>
  );
};

export default ProjectsScreen;
